import intl from 'react-intl-universal'
import moment from 'moment';


export const validatedDto = (dto, showJustification) => {  
  const today = moment().startOf("day");
  const coleta = moment(dto.volumeOrder.DataColetaProposta, "YYYY-MM-DD"); // formato ISO_DATE_FORMAT

  switch (true) {
    case coleta.isBefore(today):
      return {
        isValid: false,
        message:
          intl.get("stocks.timeline.feedback.collectionDateInPast") ||
          "A data de coleta não pode ser no passado.",
      };
    case dto.volumeOrder.VolumeAceito <= 0:
      return {
        isValid: false,
        message: intl.get("stocks.timeline.feedback.quantityFieldRequired"),
      };
    case dto.volumeOrder.DataColetaProposta >
      dto.volumeOrder.DataEntregaProposta:
      return {
        isValid: false,
        message: intl.get("requestOrders.invalidDateRange"),
      };
    case showJustification &&
      !dto.volumeOrder.TypeofJustificationSuggestionManual:
      return {
        isValid: false,
        message: intl.get("feedbacks.messageMandatoryJustification"),
      };
    case dto.volumeOrder.Observacao === "":
      return {
        isValid: false,
        message: intl.get("stocks.timeline.feedback.observationMandatory"),
      };
    case !dto.volumeOrder.IdMaterial:
    case dto.volumeOrder.IdMaterial <= 0:
      return {
        isValid: false,
        message: intl.get("feedbacks.messageMaterial"),
      };
    case !dto.volumeOrder.IdFornecedor:
    case dto.volumeOrder.IdFornecedor <= 0:
      return {
        isValid: false,
        message: intl.get("feedbacks.messageMaterialBusiness4"),
      };
    default:
      return {
        isValid: true,
        message: "",
      };
  }
};
